import React, { useState } from "react";
import { Link } from "src/components";
import { Button, Col, Divider, Row, Space, Spin } from "antd";
import { AppstoreAddOutlined } from "@ant-design/icons";

import DeleteView from "src/modules/concept/components/DeleteView";
import { EditIcon, RenderTable, Layout, MetaTag } from "src/components";

import { FilterComponent } from "src/modules/concept/components";

const ListView: React.FC = (props: any) => {
    const { loading, concepts, conceptAggregate, loadConceptsData } = props;

    const columns = [
        {
            title: "Title",
            key: "title",
            render: (text, record) => record?.title,
        },
        {
            title: "Action",
            key: "action",
            align: "right",
            render: (text, record) => (
                <Space size="middle">
                    <Link href={`/concept/update/${record?.id}`}>
                        <EditIcon isButton={true} />
                    </Link>
                    {/* <Divider />
                    <DeleteView id={record?.id} isButton={true} /> */}
                </Space>
            ),
        },
    ];

    return (
        <Layout titles={[{ name: "Concepts", link: "/concept" }]}>
            <MetaTag title="Concepts" />
            <Row justify="space-between" align="middle">
                <Col>
                    <h1>Concepts List</h1>
                </Col>
                <Col>
                    <Link href={"/concept/create"}>
                        <Button type="primary" icon={<AppstoreAddOutlined />}>
                            Add
                        </Button>
                    </Link>
                </Col>
            </Row>
            <hr />

            {/* <FilterComponent isConcept={true} {...props} /> */}
            <hr />

            <Spin spinning={loading}>
                {Boolean(concepts?.length) && (
                    <RenderTable
                        loading={loading}
                        columns={columns}
                        data={concepts || []}
                        loadData={loadConceptsData}
                        aggregate={conceptAggregate?.aggregate?.count}
                    />
                )}
            </Spin>
        </Layout>
    );
};

export default ListView;
